module.exports = __webpack_public_path__ + "static/media/emma_w.b392bd5e.png";